import {CONDITION_OPERATORS} from './condition-operators.model';
import {OPERATOR_COMPARAISON} from './operator.comparaison.model';

/**
 * Comparaisons offertes par du texte libre : l'égalité, et la recherche dans le texte — « contient »,
 * selon qu'elle respecte la casse (`LIKE`) ou non (`ILIKE`).
 *
 * Un texte ne s'ordonne pas, il n'a donc pas de comparaison de grandeur ; mais il se fouille, ce
 * qu'aucune autre nature ne permet. L'égalité vient d'abord, comme partout ailleurs.
 */
export const TEXT_CONDITION_OPERATORS: OPERATOR_COMPARAISON[] = [
    ...CONDITION_OPERATORS.slice(0, 2),
    OPERATOR_COMPARAISON.LIKE,
    OPERATOR_COMPARAISON.ILIKE,
];
